import { Card, CardContent, CardHeader, Container, Divider, makeStyles } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AlertDialog from 'src/components/AlertDialog';
import CreateEditCenterForm from 'src/components/Centers/CreateEditCenterForm';
import Page from 'src/components/Page';
import { useCreateCenter } from 'src/hooks/centers';
import { useGoBack } from 'src/hooks/common';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const CreateCenterView = () => {
  const { t } = useTranslation('centers');
  const goBack = useGoBack('/app/centers');
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const history = useHistory();
  const [createCenter, { isloading, data, isError, error }] = useCreateCenter();

  const handleSubmit = (values) => createCenter(values);

  const handleCancel = () => {
    history.push('/app/centers', { replace: true });
  };

  useEffect(() => {
    if (!isloading && !isError && data) {
      enqueueSnackbar(t('modals.success.text_create_center'), {
        variant: 'success',
      });

      goBack();
    }
  }, [data, enqueueSnackbar, goBack, isError, isloading, t]);

  return (
    <Page className={classes.root}>
      <Container maxWidth="lg">
        <Card>
          <CardHeader
            subheader={t('labels.createCenter_subtitle')}
            title={t('labels.createCenter_title')}
          />
          <Divider />
          <CardContent>
            <CreateEditCenterForm
              handleFormSubmit={handleSubmit}
              handleCancel={handleCancel}
              operation="create"
            />

            {isError && (
              <AlertDialog
                title={t('modals.error.title_create_center')}
                text={error?.message || t('modals.error.text_create_center')}
                type="error"
              />
            )}
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default CreateCenterView;
